import { createFileRoute } from '@tanstack/react-router';
import { AdminAiUsage } from '@/components/admin/admin-ai-usage';

export const Route = createFileRoute('/admin/usage')({
  component: AdminAiUsage,
});
